Apt.fn.extend('filters', {}, {
	/**
	 * Bind more input events
	 */
	bindMore() {
		const scope = this;
		const options = {
			cancel: true,
			namespace: 'filters'
		};

		$.events.on({
			'$filterDom': {
				input: (e, el) => {
					el.blur();

					scope.merge();
				}
			},
			'$filterInput': {
				input: () => {
					scope.merge();
				}
			},
			'$filterKeywords': {
				blur: (e, el) => {
					scope.merge({
						keywords: el.value.trim()
					});
				}
			},
			'$filterMap': {
				change: (e, el) => {
					const hide = el.checked;

					$('.properties').toggleClass('-is-filled', hide);

					if (! hide) {
						Apt.properties.$private.map.resize();
					}
				}
			},
			'$filterStructure': {
				change: (e, el) => {
					scope.merge({
						structure: el.value
					});
				}
			},
			'$filterToggle': {
				change: (e, el) => {
					$.app.filters.$set('input.' + el.name, el.checked ? el.value : '');

					scope.merge();
				}
			}
		}, options);
	},

	/**
	 * Merge advanced criteria count data
	 *
	 * @param {Object} data
	 * @returns {Object}
	 */
	count(data) {
		data.criteria = data.more = 0;

		this.criteria.forEach(key => {
			const val = data.input[key];

			if (val) {
				data.criteria += $.toArray(val).length;
			}
		});

		this.more.forEach(key => {
			const val = data.input[key];

			if (val) {
				if ($.isObject(val) && ! val.min && ! val.max) {
					return;
				}

				data.more++;
			}
		});

		return data;
	}
});